import t from "../../i18n";

export const nonEmptyStringValidation = (v: string) =>
  v ? undefined : t("errors.field_cannot_be_empty");

export const strictlyPositiveNumberValidation = (v: string) =>
  !v || window.isNaN(Number(v)) || Number(v) <= 0
    ? t("errors.field_must_be_strictly_positive_number")
    : undefined;

export const numberValidation = (v: string) =>
  !v || window.isNaN(Number(v)) ? t("errors.field_must_be_number") : undefined;

export const nullableNumberValidation = (v: string) =>
  v && window.isNaN(Number(v)) ? t("errors.field_must_be_number") : undefined;

export const nullableStrictlyPositiveNumberValidation = (v: string) =>
  v && (window.isNaN(Number(v)) || Number(v) <= 0)
    ? t("errors.field_must_be_strictly_positive_number")
    : undefined;
